















import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { User } from "../../store/auth/types";

const authStore = namespace("auth");

@Component
export default class NamePlate extends Vue {
  @authStore.Action ensureCurrentProfile!: () => Promise<void>;
  @authStore.State("profile") profile!: User;

  get fullName(): string {
    if (this.profile === undefined) return "";
    return this.profile.first_name + " " + this.profile.last_name;
  }

  private mounted() {
    this.ensureCurrentProfile();
  }
}
